import {
  activate,
  deactivate,
  logger,
  warn,
  Level,
  status,
  updateLogger,
} from "@otto-ec/global-debug";
import { o_global } from "../namespaces";

const debug = {
  /**
 *
 *
 */
  activate,
  /**
 *
 */
  deactivate,
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  logger,
  /**
 *
 */
  Level,
  /**
 *
 */
  status,

  warn,
};

/**
 *
 */
export type GlobalDebug = Omit<typeof debug, "warn">;

/*                            */
updateLogger(status());

/*                                              */
o_global.debug ||= debug;
